import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/inventory/$slug")({
  head: () => pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/inventory/:slug' }),
  beforeLoad: () => {
    throw redirect({ href: "/rv-search" });
  },
});
